import React from "react";
import {BrowserRouter as Router, Route, Switch,} from "react-router-dom";
import Application from "./Components/Application";
import "./styles/styles.standalone.css"

export default function OdezaAppStandalone(props) {
    return (
        <Router>
            <Switch>
                <Route
                    path="/"
                    render={(routeProps =>
                            <Application
                                {...routeProps}
                                {...props}
                            />
                    )}
                />
            </Switch>
        </Router>
    );
}